import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const { spacing, colors, typography, common } = THEME;

export const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	attachmentsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	attachmentItem: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: spacing.sm,
		backgroundColor: colors.background.light,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.light}`,
	},
	attachmentInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	attachmentName: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
	},
	attachmentNameLink: {
		padding: 0,
		height: 'auto',
		justifyContent: 'flex-start',
	},
	attachmentSize: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
	},
	uploadContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		padding: spacing.md,
		border: `2px dashed ${colors.border.light}`,
		borderRadius: common.borderRadius,
		textAlign: 'center',
	},
	uploadText: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
	},
	fileInput: {
		display: 'none',
	},
	emptyState: {
		textAlign: 'center',
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		padding: spacing.md,
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.xs,
		padding: spacing.xs,
		backgroundColor: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
	},
});
